import { Button, Container, Grid, Typography } from '@mui/material'
import { Box } from '@mui/system'
import './soloar.css'
import Moon from './moon.svg'
import Lkin from './in.svg'
import twitter from './twitter.svg'
import fb from './fb.svg'
import tele from './tele.svg'
import { Link } from 'react-router-dom'

export default function Solar() {
  return (
    <>
      <Box mt={30} style={{ color: 'white' }} id="solar">
        <Container>
          <Box sx={{ textAlign: 'center' }}>
            <img src={Moon} alt={Moon} style={{ width: '100px' }} />
            <Typography
              style={{ fontSize: '40px', textShadow: '0px 0px 20px white' }}
            >
              SOLAR
            </Typography>
          </Box>
          <Grid
            container
            justifyContent={{ xs: 'center', md: 'space-between' }}
            mt={10}
          >
            <Grid item xs={12} md={3} mt={{ xs: 10, md: 0 }}>
              <Container>
                <Typography paragraph color="white">
                  About
                </Typography>
                <Typography
                  fontSize={{ xs: '15px', md: '13px' }}
                  sx={{ color: 'white' }}
                >
                  Solar is the first US based Solana Defi exchange that enables
                  users to trade tokens on the Solano network. Solar plans to
                  eliminate rug pulls by having our smart contracts
                  automatically lock liquidity at a minimum of 3 months. Any
                  token not using Solar…. Is most likely a scam
                </Typography>
              </Container>
            </Grid>
            <Grid item xs={12} sm={6} md={3} mt={{ xs: 10, md: 0 }}>
              <Container>
                <Typography paragraph>FOLLOW US</Typography>

                <Grid
                  container
                  justifyContent="flex-start"
                  alignItems="center"
                  columnGap={4}
                  width={{ xs: '50%', md: '100%' }}
                  margin={{ xs: '0px', md: '"50px auto 0px auto"' }}
                >
                  <Grid item>
                    <a target="_blank" href="https://twitter.com/solar_dex?s=21">
                      <img src={twitter} />
                    </a>
                  </Grid>
                 
                  <Grid item>
                    <a target="_blank" href="https://t.me/solardexofficialchat">
                      {' '}
                      <img src={tele} />{' '}
                    </a>
                  </Grid>
                </Grid>
                <Typography sx={{ fontSize: '12px' }} mt={3}>
                  All rights reserved @solardex 2021
                </Typography>
              </Container>
            </Grid>
            <Grid item xs={12} sm={6} md={3} mt={{ xs: 10, md: 0 }}>
              <Box>
                <Typography paragraph sx={{ texTransformation: 'uppercase' }}>
                  Subscribe Now
                </Typography>
                {/* <img src={Field} alt={Field} width="300px"/> */}
                <Grid container>
                  <Grid item color="white">
                    <input
                      type="mail"
                      style={{
                        height: '37px',
                        margin: 'auto',
                        background: '#190436',
                        color: 'white',
                        border: '1px solid white',
                        borderRight: '0px',
                        outline: 'none',
                        textIndent: '10px',
                        boxShadow: '0px 0px 5px white',
                      }}
                      placeholder="Write Your Mail"
                    />
                    <Button
                      style={{
                        height: '41px',
                        width: '77px',
                        background: 'aqua',
                        borderTopLeftRadius: '40px',
                        borderBottomLeftRadius: '40px',
                        color: 'black',
                        fontWeight: 'bolder',
                        marginLeft: '-22px',
                        marginTop: '-1px',
                      }}
                    >
                      {' '}
                      Send{' '}
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  )
}
